module.exports = __webpack_public_path__ + "img/core.e7f7d133.jpg";